import { Component, Input, OnChanges, OnInit, SimpleChanges, TemplateRef } from '@angular/core';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { bootstrapArrowBarLeft, bootstrapArrowBarRight, bootstrapDoorOpen, bootstrapGear, bootstrapHouse, bootstrapMenuButtonWide, bootstrapTruck } from '@ng-icons/bootstrap-icons';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { NavigationItem } from '../../../shared/navigation/navigation.reducer';
import { IRootState } from '../../app.config';
import { JsonPipe } from '@angular/common';
import { BrandingLogoDisplayComponent } from '../../../shared/branding/branding-logo-display/branding-logo-display.component';
import { IUserConfiguration, selectFreightTypesEnabled } from '../../../shared/user/user.reducer';

@Component({
  selector: 'app-navigation',
  standalone: true,
  imports: [RouterLink, NgIconComponent, JsonPipe, BrandingLogoDisplayComponent, RouterLinkActive],
  templateUrl: './navigation.component.html',
  styleUrl: './navigation.component.scss',
  viewProviders: [provideIcons(
    {
      bootstrapMenuButtonWide,
      bootstrapDoorOpen,
      bootstrapGear,
      bootstrapArrowBarRight,
      bootstrapArrowBarLeft,
      bootstrapTruck,
      bootstrapHouse
    })]
})
export class NavigationComponent implements OnInit {

  @Input()
  navigationItems: NavigationItem[] | null = [];
  @Input()
  userConfig: IUserConfiguration | null = null;

  constructor(private store$: Store<IRootState>, private offCanvasService: NgbOffcanvas, private router: Router) { }
  ngOnInit(): void {

  }

  openNavigation(content: TemplateRef<any>) {
    this.offCanvasService.open(content, {});
  }

  openDashboard() {
    this.router.navigate(['/app/dashboard']);
    this.dismissNavigationTray();
  }

  openOrders() {
    this.router.navigate(['/app/order/home']);
    this.dismissNavigationTray();
  }

  openContainers() {
    this.router.navigate(['/app/containers/home']);
    this.dismissNavigationTray();
  }

  openSpecialisedFreight() {
    this.router.navigate(['/app/jobbing/home']);
    this.dismissNavigationTray();
  }

  dismissNavigationTray() {
    this.offCanvasService.dismiss();
  }
}
